import React from 'react';
export function TeachingFlow({
  steps,
  className = ''
}: {
  steps: string[];
  className?: string;
}) {
  return <p className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/65 ${className}`} data-id="element-169" data-mp="34t4sg2e2hjsf">
      {steps.map((step, index) => <React.Fragment key={step} data-id="element-170" data-mp="3eoyce6u48fk8" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className="text-brand-gold" data-id="element-171" data-mp="3sgwdbudob55b">
              →
            </span>}
          <span data-id="element-172" data-mp="3ofaulsegjwn7">{step}</span>
        </React.Fragment>)}
    </p>;
}